var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "training" }, [
    _c(
      "div",
      { staticClass: "top" },
      [
        _c("span", [_vm._v("Status do treinamento do profisisonal")]),
        _vm._v(" "),
        _c(
          "v-tooltip",
          {
            attrs: { "open-delay": "0", "close-delay": "0", right: "" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "v-chip",
                      _vm._g(
                        {
                          attrs: {
                            color: _vm._f("getStatus")(
                              _vm.trainingStatus,
                              "color"
                            ),
                            "align-center": ""
                          }
                        },
                        on
                      ),
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("getStatus")(_vm.trainingStatus, "name")
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          },
          [
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm._f("getStatus")(_vm.trainingStatus, "description"))
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isTrainingApproved(_vm.trainingStatus)
      ? _c(
          "div",
          { staticClass: "bottom" },
          [
            _vm.canStartTraining
              ? _c(
                  "v-btn",
                  {
                    attrs: { loading: _vm.loader, small: "", color: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.startTraining()
                      }
                    }
                  },
                  [_vm._v("\n      Iniciar treinamento\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canApproveOnTraining
              ? _c(
                  "v-btn",
                  {
                    attrs: { loading: _vm.loader, small: "", color: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.approveTraining()
                      }
                    }
                  },
                  [_vm._v("\n      Aprovar treinamento\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canReproveOnTraining
              ? _c(
                  "v-btn",
                  {
                    attrs: { loading: _vm.loader, small: "", color: "error" },
                    on: {
                      click: function($event) {
                        return _vm.reproveOnTraining()
                      }
                    }
                  },
                  [_vm._v("\n      Reprovar treinamento\n    ")]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41c3e67f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c3e67f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Register/Steps/Training.vue
// module id = null
// module chunks = 